/*
 * Module for APROA Authorization step
 */
rs.module("content/retirementapplication/aproaauthorization",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {
            const authorizeYes = $.js(jsSelectors.authorizeYes);
            const authorizeNo = $.js(jsSelectors.authorizeNo);
            const infoSection = $.js(jsSelectors.infoSection);

            function toggleInfoSection() {
                if (authorizeYes.is(':checked')) {
                    infoSection.show();
                } else {
                    infoSection.hide();
                }
            }

            // Event Listeners
            authorizeYes.on('change', toggleInfoSection);
            authorizeNo.on('change', toggleInfoSection);

            // Initialize based on current state
            toggleInfoSection();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
